import React, { useState } from "react";
import { Button, Col, Modal, Row, Typography, Spin, Tabs } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { getPacksQuery } from "dataLayer/pack";
import {
  PACK_NAME,
  PACK_UNIT,
  PACK_UNIT_MODAL,
  CHANCE_NAME,
} from "@pages/AccountPage/components/AccountSubscription";

import "./modal.scss";
import BitelModal, { ModalConfirm } from "./index";
import OtpModal from "./OtpModal";
import { useRegisterPack, useRequestOtpPackage } from "dataLayer/user";
import TermAccept from "@components/TermAccept";
import useStateTermAccept from "@components/TermAccept/hook";

const { Title } = Typography;
const { TabPane } = Tabs;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const BitelChoosePack = ({
  title,
  visible,
  handleClose,
  bidTotal,
  packagePackLength,
}) => {
  const DEFAULT_TAB = "tab_1";
  const { data: packs, isLoading: isLoadingRegister } = useQuery(
    getPacksQuery()
  );
  const { t } = useTranslation();

  const [selectedPack, setSelectedPack] = useState();
  const [selectedPackPrice, setSelectedPackPrice] = useState();
  const { acceptTerms, setAcceptTerms, showError, setShowError } =
    useStateTermAccept();
  const [displayConfirm, setDisplayConfirm] = useState(false);
  const [displayOtp, setDisplayOtp] = useState(false);
  const [currentTab, setCurrentTab] = useState(DEFAULT_TAB);
  const [bidTotalHideSub, setbidTotalHideSub] = useState(false);

  React.useEffect(() => {
    if (bidTotal === 0 && packagePackLength?.length > 0) {
      setbidTotalHideSub(true);
    } else {
      setbidTotalHideSub(false);
    }
  }, [bidTotal, bidTotalHideSub, packagePackLength]);

  const {
    mutate: mutateRegisterPack,
    data: dataRegisterPack,
    error: errorRegisterPack,
    isLoading,
  } = useRegisterPack();
  const { mutate: mutateGetOTP, data: dataGetOtp } = useRequestOtpPackage();

  const callback = (key) => {
    setCurrentTab(key);
  };

  const handleClick = (packId, packPrice) => () => {
    setSelectedPack(packId);
    if (typeof packPrice !== "undefined") {
      setSelectedPackPrice(packPrice);
    }
  };

  const handleOk = () => {
    handleClose();
    setDisplayConfirm(false);
    if (!selectedPack) {
      return;
    }
    if (selectedPack.startsWith("SUBASTA")) {
      mutateRegisterPack({ packId: selectedPack, isRegister: true });
    } else {
      mutateGetOTP({ selectedPackPrice, selectedPack });
      setDisplayOtp(true);
    }
  };

  const handleClickRegister = () => {
    setShowError(!acceptTerms);
    if (acceptTerms) {
      setDisplayConfirm(true);
    }
  };

  const closeConfirm = () => setDisplayConfirm(false);

  const handleCancelOtp = () => {
    setDisplayOtp(false);
  };

  return (
    <>
      <Modal
        className="page-modal page-modal-buy-pack"
        centered
        maskClosable={false}
        visible={visible}
        onCancel={handleClose}
        footer={[
          <Row justify="center" key={1}>
            <Col md={24}>
              <Button
                className="page-modal-button"
                onClick={handleClickRegister}
                loading={isLoading}
                disabled={!selectedPack}>
                {t("bid.buy_now")}
              </Button>
              <TermAccept
                acceptTerms={acceptTerms}
                setAcceptTerms={setAcceptTerms}
                showError={showError}
              />
            </Col>
          </Row>,
        ]}>
        <Row className="page-modal-package" justify="start">
          <Col md={24}>
            <Title level={3} className="page-modal-title-buy-now">
              {title}
            </Title>

            <Title
              level={3}
              className={`page-modal-title-package ${
                bidTotalHideSub ? "d-none" : ""
              }`}
              // className="page-modal-title-package"
            >
              {t("bid.package_subscription")}
            </Title>
            <Row
              className={`page-modal-content ${
                bidTotalHideSub ? "d-none" : ""
              }`}
              // className="page-modal-content"
            >
              {isLoadingRegister ? (
                <Spin indicator={antIcon} />
              ) : (
                packs?.map((pack, index) => {
                  let additionClass = "";
                  if (selectedPack) {
                    additionClass =
                      selectedPack === pack?.pack_id
                        ? "buy-subscription-item-selected"
                        : "buy-subscription-item-not-selected";
                  }
                  return (
                    <>
                      {pack?.cycle != null ? (
                        <Col xs={12} sm={12} md={8} lg={8} key={index}>
                          <div
                            className={`buy-subscription-item buy-subscription-item-package ${additionClass}`}
                            onClick={handleClick(pack?.pack_id)}>
                            <Title
                              level={5}
                              className="buy-subscription-item-title">
                              {t("account.subscription_page.type_pack").replace(
                                "_TYPE_",
                                PACK_NAME[pack?.cycle] || pack?.cycle
                              )}
                            </Title>
                            <Title
                              level={5}
                              className="buy-subscription-item-sub-title">
                              {t(
                                "account.subscription_page.bid_per_pack"
                              ).replace("_TURN_", pack?.max_turn)}
                              {t(
                                "account.subscription_page.time_per_pack"
                              ).replace(
                                "_TIME_",
                                PACK_UNIT[pack?.cycle] || "day"
                              )}
                            </Title>
                            <Title
                              level={5}
                              className="buy-subscription-item-price">
                              <span className="buy-subscription-item-price-number">
                                {t("currency_sign")}
                                {pack?.price / 10000}
                              </span>
                              <span className="buy-subscription-item-price-time">
                                {t(
                                  "account.subscription_page.time_per_pack_modal"
                                ).replace(
                                  "_TIME_",
                                  PACK_UNIT_MODAL[pack?.cycle] || "day"
                                )}
                              </span>
                            </Title>
                          </div>
                        </Col>
                      ) : null}
                    </>
                  );
                })
              )}
            </Row>

            <Title
              level={3}
              className="page-modal-title-package"
              style={{ marginTop: "20px" }}>
              {t("bid.buy_more_bids")}
            </Title>
            <Row className="page-modal-content">
              {isLoadingRegister ? (
                <Spin indicator={antIcon} />
              ) : (
                packs?.map((pack, index) => {
                  let additionClass = "";
                  if (selectedPack) {
                    additionClass =
                      selectedPack === pack?.pack_id
                        ? "buy-subscription-item-selected"
                        : "buy-subscription-item-not-selected";
                  }
                  return (
                    <>
                      {pack?.cycle == null ? (
                        <Col xs={12} sm={12} md={6} lg={6} key={index}>
                          <div
                            className={`buy-subscription-item chance-subscription-item ${additionClass}`}
                            onClick={handleClick(pack?.pack_id, pack?.price)}>
                            <Title
                              level={5}
                              className="buy-subscription-item-title">
                              {t("account.subscription_page.type_pack").replace(
                                "_TYPE_",
                                CHANCE_NAME[pack?.max_turn] || pack?.pack_id
                              )}
                            </Title>
                            <Title
                              level={5}
                              className="buy-subscription-item-sub-title">
                              {pack?.max_turn === 1
                                ? t(
                                    "account.subscription_page.one_bid"
                                  ).replace("_TURN_", pack?.max_turn)
                                : t(
                                    "account.subscription_page.bid_per_pack"
                                  ).replace("_TURN_", pack?.max_turn)}
                            </Title>
                            <Title
                              level={5}
                              className="buy-subscription-item-price">
                              <span className="buy-subscription-item-price-number">
                                {t("currency_sign")}
                                {pack?.price / 10000}
                              </span>
                            </Title>
                          </div>
                        </Col>
                      ) : null}
                    </>
                  );
                })
              )}
            </Row>
          </Col>
        </Row>
        <Row className="page-modal-chance" justify="start">
          <Col md={24}>
            <Title level={3} className="page-modal-title-buy-now">
              {title}
            </Title>
            <Tabs
              className="chance-page-tabs"
              type="card"
              size="small"
              activeKey={bidTotalHideSub ? "tab_2" : currentTab}
              defaultActiveKey={bidTotalHideSub ? "tab_2" : "tab_1"}
              onTabClick={callback}>
              <TabPane
                tab={t("bid.package")}
                key="tab_1"
                disabled={bidTotalHideSub}>
                <Title level={3} className="page-modal-title-package">
                  {t("bid.package_subscription")}
                </Title>
                <Row className="page-modal-content">
                  {isLoadingRegister ? (
                    <Spin indicator={antIcon} />
                  ) : (
                    packs?.map((pack, index) => {
                      let additionClass = "";
                      if (selectedPack) {
                        additionClass =
                          selectedPack === pack?.pack_id
                            ? "buy-subscription-item-selected"
                            : "buy-subscription-item-not-selected";
                      }
                      return (
                        <>
                          {pack?.cycle != null ? (
                            <Col xs={12} sm={12} md={8} lg={8} key={index}>
                              <div
                                className={`buy-subscription-item buy-subscription-item-package ${additionClass}`}
                                onClick={handleClick(pack?.pack_id)}>
                                <Title
                                  level={5}
                                  className="buy-subscription-item-title">
                                  {t(
                                    "account.subscription_page.type_pack"
                                  ).replace(
                                    "_TYPE_",
                                    PACK_NAME[pack?.cycle] || pack?.cycle
                                  )}
                                </Title>
                                <Title
                                  level={5}
                                  className="buy-subscription-item-sub-title">
                                  {t(
                                    "account.subscription_page.bid_per_pack"
                                  ).replace("_TURN_", pack?.max_turn)}
                                  {t(
                                    "account.subscription_page.time_per_pack"
                                  ).replace(
                                    "_TIME_",
                                    PACK_UNIT[pack?.cycle] || "day"
                                  )}
                                </Title>
                                <Title
                                  level={5}
                                  className="buy-subscription-item-price">
                                  <span className="buy-subscription-item-price-number">
                                    {t("currency_sign")}
                                    {pack?.price / 10000}
                                  </span>
                                  <span className="buy-subscription-item-price-time">
                                    {t(
                                      "account.subscription_page.time_per_pack_modal"
                                    ).replace(
                                      "_TIME_",
                                      PACK_UNIT_MODAL[pack?.cycle] || "day"
                                    )}
                                  </span>
                                </Title>
                              </div>
                            </Col>
                          ) : null}
                        </>
                      );
                    })
                  )}
                </Row>
              </TabPane>

              <TabPane tab={t("bid.buy_more_bids")} key="tab_2">
                <Title
                  level={3}
                  className="page-modal-title-package"
                  style={{ marginTop: "20px" }}>
                  {t("bid.buy_more_bids")}
                </Title>
                <Row className="page-modal-content">
                  {isLoadingRegister ? (
                    <Spin indicator={antIcon} />
                  ) : (
                    packs?.map((pack, index) => {
                      let additionClass = "";
                      if (selectedPack) {
                        additionClass =
                          selectedPack === pack?.pack_id
                            ? "buy-subscription-item-selected"
                            : "buy-subscription-item-not-selected";
                      }
                      return (
                        <>
                          {pack?.cycle == null ? (
                            <Col xs={12} sm={12} md={6} lg={6} key={index}>
                              <div
                                className={`buy-subscription-item chance-subscription-item chance-subscription-item-small ${additionClass}`}
                                onClick={handleClick(
                                  pack?.pack_id,
                                  pack?.price
                                )}>
                                <Title
                                  level={5}
                                  className="buy-subscription-item-title">
                                  {t(
                                    "account.subscription_page.type_pack"
                                  ).replace(
                                    "_TYPE_",
                                    CHANCE_NAME[pack?.max_turn] || pack?.pack_id
                                  )}
                                </Title>
                                <Title
                                  level={5}
                                  className="buy-subscription-item-sub-title">
                                  {pack?.max_turn === 1
                                    ? t(
                                        "account.subscription_page.one_bid"
                                      ).replace("_TURN_", pack?.max_turn)
                                    : t(
                                        "account.subscription_page.bid_per_pack"
                                      ).replace("_TURN_", pack?.max_turn)}
                                </Title>
                                <Title
                                  level={5}
                                  className="buy-subscription-item-price">
                                  <span className="buy-subscription-item-price-number">
                                    {t("currency_sign")}
                                    {pack?.price / 10000}
                                  </span>
                                </Title>
                              </div>
                            </Col>
                          ) : null}
                        </>
                      );
                    })
                  )}
                </Row>
              </TabPane>
            </Tabs>
          </Col>
        </Row>
      </Modal>
      <BitelModal
        defaultMsg={t("account.subscription")}
        data={dataRegisterPack}
        error={errorRegisterPack}
        titleSuccess={t("success")}
        btnSuccess={t("modal.thank")}
      />
      <ModalConfirm
        visible={displayConfirm}
        message={t("account.bid_history_page.confirm_msg")}
        title={t("confirm")}
        handleOk={handleOk}
        handleCancel={closeConfirm}
        isShowAcceptTerm={false}
      />
      <OtpModal
        visible={displayOtp}
        handleCancelOtp={handleCancelOtp}
        dataGetOtp={dataGetOtp}
        selectedPackPrice={selectedPackPrice}
        selectedPack={selectedPack}
      />
    </>
  );
};

export default BitelChoosePack;
